export const RESET_ORGANIZATION_STATE = 'RESET_ORGANIZATION_STATE';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const GET_ORGANIZATION_KINDERGARTENS = 'GET_ORGANIZATION_KINDERGARTENS';
export const SET_ORGANIZATION_KINDERGARTENS = 'SET_ORGANIZATION_KINDERGARTENS';